import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../elements";
import { useNavigate } from 'react-router-dom';
import { ProgressBar } from "react-bootstrap";
import "./RescuePageComponentStyles.css"
import axios from "axios";
import DownloadIcon from "@mui/icons-material/Download";
import { Dropdown, Form } from "react-bootstrap";

export default function RescueTableComponent({ thead, tbody, roleId, donors, onChangeRole }) {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();
  const [alertModal, setAlertModal] = useState(false);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const AuthToken = localStorage.getItem("AuthUser");


  useEffect(() => {
    setData(tbody);
  }, [tbody]);



  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    // setCurrentPage(1); 
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery)
    )
  );

  //     const totalItems = filteredData.length;
  //     const totalPages = Math.ceil(totalItems / itemsPerPage);
  //     const startIndex = (currentPage - 1) * itemsPerPage;
  //     const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);
  //  const [pageWindowStart, setPageWindowStart] = useState(1);
  //   const visiblePages = 2;

  //     const handlePageChange = (page) => {
  //         if (page > 0 && page <= totalPages) {
  //             setCurrentPage(page);
  //         }
  //     };

  const downloadPdf = async (personId) => {
    const personData = await axios.get(
      process.env.REACT_APP_API_URL + `/family-short-pdf/${personId}`
    );
    const win = window.open(personData.data.pdf, "_blank");
    if (win != null) {
      win.focus();
    }
  };
  const navigateToEdit = (id) => {
    navigate(`/edit-family/${id}`);
  };

  return (<>
    <div className="mc-table-responsive main-div">
      <div className="mc-search tabble-search-box">
        <input
          type="text"
          placeholder={t('search')}
          value={searchQuery}
          onChange={handleSearch}
          className="form-control table-search"
        />
      </div>
      <div className="table-container-responsive">
        <div className="table-scrollable">
          <table className="mc-table product">
            <thead className="mc-table-head table-header"
              style={{ backgroundColor: "#077834", color: "#fff" }}>
              <tr>
                <th><div className="mc-table-check"><p>FSF-ID</p></div></th>
                {thead.map((item, index) => (
                  <th key={index}>{t(item)}</th>
                ))}
              </tr>
            </thead>

            <tbody className="mc-table-body table-body ">
              {filteredData.map((item, index) => (
                <tr key={index}>
                  <td><div className="mc-table-check"><p>{item.fsf_id}</p></div></td>
                  <td>
                    <div className="mc-table-product md">
                      <div className="mc-table-group">
                        <h6>
                          <p>{item.beneficiary_name}</p>
                          <p>{item.beneficiary_cnic}</p>
                        </h6>
                      </div>

                    </div>
                  </td>

                  {roleId == 4 && <td>
                    <div>
                      <Form.Group className="w-sm h-sm">
                        <Form.Select
                          name="donor"
                          onChange={(e) => onChangeRole(e, item.id)}
                        >
                          <option value="">Select Donor</option>
                          {donors?.map((donor) => {
                            return (
                              <option value={donor.id} selected={item.family_donor_id === donor.id ? true : false}>{donor.name}</option>
                            )
                          })}
                        </Form.Select>
                      </Form.Group>


                    </div>
                  </td>}
                  <td>
                    <p>{item.partner_name}</p>
                    <p>{item.organization_church}</p>
                  </td>
                  <td>{item.verified_by}</td>
                  <td>Rescued</td>
                  <td>
                    <div>
                      <ProgressBar className="bar" variant="success" now={item?.progress} />
                      <p className="text-center">{item.progress}%</p>
                    </div>
                  </td>
                  <td>
                    <div className="mc-table-action">
                      <AnchorComponent
                        to={`/family-report/${item.fsf_id}`}
                        title="View"
                        className="material-icons view"
                        style={{ backgroundColor: "rgba(7, 120, 52, 0.7)", color: "white" }}
                      >
                        {item.action.view}
                      </AnchorComponent>
                      <AnchorComponent
                        to={`/family-rescue-form/${item.id}`}
                        title="Edit"
                        className="material-icons edit"
                        style={{ backgroundColor: "rgba(7, 120, 52, 0.7)", color: "white" }}
                      >
                        {item.action.edit}
                      </AnchorComponent>

                      <ButtonComponent
                        type="button"
                        title="Download Short Report"
                        className="material-icons edit"
                        onClick={() => downloadPdf(item.id)}
                        style={{
                          color: "#fff",
                          backgroundColor:
                            "rgba(7, 120, 52, 0.7)",
                          borderRadius: "5px",
                          padding: "5px",
                        }}
                      >
                        <DownloadIcon fontSize="small" />
                      </ButtonComponent>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


    </div>

    {/* Pagination */}
    {/* <div className="mc-paginate">
  <p className="mc-paginate-title">
    {t('showing')}
    <b> {startIndex + 1} </b>
    {t('to')}
    <b> {Math.min(startIndex + itemsPerPage, totalItems)} </b>
    {t('of')}
    <b> {totalItems} </b>
    {t('results')}
  </p>

  <ul className="mc-paginate-list">
  <li
  style={{
    color: "#077834 ",
    backgroundColor: "#e8f5e9",
    borderRadius: "4px",
    padding: "5px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#077834";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#e8f5e9";
    e.currentTarget.style.color = "#077834";
  }}
  onClick={() => {
    const newStart = Math.max(1, pageWindowStart - visiblePages);
    setPageWindowStart(newStart);
  }}
>
  <i className="material-icons">chevron_left</i>
</li>


    {Array.from(
      { length: Math.min(visiblePages, totalPages - pageWindowStart + 1) },
      (_, i) => pageWindowStart + i
    ).map((pageNum) => {
      const isActive = pageNum === currentPage;
      return (
        <li
          key={pageNum}
          style={{
            backgroundColor: isActive ? "#077834" : "#e8f5e9",
            color: isActive ? "#fff" : "#077834",
            borderRadius: "4px",
            padding: "5px 10px",
            margin: "0 4px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#06622a";
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = isActive
              ? "#077834"
              : "#e8f5e9";
            e.currentTarget.style.color = isActive ? "#fff" : "#077834";
          }}
          onClick={() => handlePageChange(pageNum)}
        >
          {pageNum}
        </li>
      );
    })}

   <li
  style={{
    color: "#077834",
    backgroundColor: "#e8f5e9",
    borderRadius: "4px",
    padding: "5px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#077834";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#e8f5e9";
    e.currentTarget.style.color = "#077834";
  }}
  onClick={() => {
    const newStart = Math.min(
      totalPages - visiblePages + 1,
      pageWindowStart + visiblePages
    );
    setPageWindowStart(newStart);
  }}
>
  <i className="material-icons">chevron_right</i>
</li>

  </ul>
</div> */}


    {/* Alert Modal */}
    <Modal show={alertModal} onHide={() => setAlertModal(false)}>
      <div className="mc-alert-modal">
        <i className="material-icons">new_releases</i>
        <h3>Are you sure?</h3>
        <p>Want to delete this product?</p>
        <Modal.Footer>
          <ButtonComponent
            type="button"
            className="btn btn-secondary"
            onClick={() => setAlertModal(false)}
          >
            {t('close')}
          </ButtonComponent>
          <ButtonComponent
            type="button"
            className="btn btn-danger"
            onClick={() => setAlertModal(false)}
          >
            {t('delete')}
          </ButtonComponent>
        </Modal.Footer>
      </div>
    </Modal>
  </>
  );
}
